import { FEATURE_ONLY_LAYOUT_DEFAULT } from 'App/features';
import { useStatusFeatureByKey } from 'domains/Auth/hooks';

export function useThemesRequireUpsell() {
  const { isAvailable } = useStatusFeatureByKey(FEATURE_ONLY_LAYOUT_DEFAULT);

  return isAvailable;
}
